import LandingPage from "./landing-page";

export default LandingPage